import React, { useEffect, useState } from 'react';
import axios from 'axios';

/**
 * AssignmentBanner — shows the student WHAT they're working on and WHO
 * assigned it ("Unit 1 AP Gov Test Review · from Ms. Smith · Period 3").
 *
 * Field-requested by a cohort teacher: grounding was audible-only (Mira
 * names the materials), so the screen still looked like a generic tutor.
 * Mirrors the server-side session grounding: explicit ?notebook_assignment
 * share token first, else the newest active assignment for the student's
 * class roster. Renders nothing for general tutoring sessions.
 */
const AssignmentBanner = () => {
  const [assignment, setAssignment] = useState(null);

  useEffect(() => {
    const token = new URLSearchParams(window.location.search).get('notebook_assignment') || '';
    axios.get('/api/notebooks/my-assignment', { params: token ? { token } : {} })
      .then((r) => setAssignment(r.data?.assignment || null))
      .catch(() => {});
  }, []);

  if (!assignment) return null;

  const due = assignment.due_at ? new Date(assignment.due_at) : null;

  return (
    <div style={{
      display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap',
      background: 'rgba(41, 122, 146, 0.10)',
      border: '1px solid rgba(41, 122, 146, 0.25)',
      borderRadius: 12, padding: '10px 16px', margin: '0 auto 14px',
      maxWidth: 800, width: '100%', fontSize: 14, lineHeight: 1.4,
    }}>
      <span aria-hidden="true" style={{ fontSize: 18 }}>📔</span>
      <div style={{ flex: 1, minWidth: 200 }}>
        <div style={{ fontWeight: 600 }}>{assignment.title}</div>
        <div style={{ opacity: 0.75, fontSize: 12.5 }}>
          Assignment from {assignment.teacher_name}
          {assignment.class_name ? ` · ${assignment.class_name}` : ''}
          {due ? ` · due ${due.toLocaleDateString()}` : ''}
          {' — Mira has your class materials ready, and your teacher will see your progress.'}
        </div>
      </div>
    </div>
  );
};

export default AssignmentBanner;
